module.exports = "\n<h1 jhiTranslate=\"legal.title\">mentions legales</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/entities/legal/legal.component.html
// module id = 447
// module chunks = 0